import { createAction, props } from '@ngrx/store';
import { ICompany } from '@shared/models/company.model';

export const addOREditFilter = createAction(
  '[Filter] Add',
  props<{ filter_name: string; value: string | number | boolean | ICompany }>()
);

export const deleteFilter = createAction(
  '[Filter] Delete',
  props<{ filter_name: string }>()
);

export const deleteAllFilters = createAction('[Filter] Delete All');
